<template>
  <div>
    <div class="top">
      <img id="logo" :src="staticUrl + 'logo/T9LOGO.png'" @click="initDoc" />

      <div class="playerBox">
        <el-radio v-model="playGameForm.walletType" label="0">一般钱包</el-radio>
        <!-- <el-radio v-model="playGameForm.walletType" label="1">免转钱包1</el-radio> -->
        <el-radio v-model="playGameForm.walletType" label="2">免转钱包2</el-radio>
        <el-radio v-model="playGameForm.walletType" label="3" v-if="isDevEnv">JDB錢包</el-radio>

        <div class="currencyBox">
          <select class="selectClass" v-model="currentCurrency" v-on:change="onCurrencyChange">
            <option class="optionClass" v-for="item in currencys" :value="item" :key="item.index">
              {{ item }}
            </option>
          </select>
        </div>

        <div class="langBox" @click="requestShow">
          <img v-bind:src="getlang" alt="" id="mylang" />

          <i class="el-icon-d-caret"></i>

          <div class="langOptions" v-if="showOpt">
            <div v-for="item in langsopts" :key="item.id" class="langItem" @click="setLangs(item)">
              <img v-bind:src="item.imgs" alt="" id="mylang" class="optlang" />

              <span>{{ item.values }}</span>
            </div>
          </div>
        </div>

        <input v-model="formData.playerID" maxlength="51" class="idType" placeholder="playerID" />
        <input v-if="isDevEnv" v-model="inputAmount" maxlength="9" class="idType" placeholder="0-10000000" />
        <div :class="{ hasTrial: IsTrial, trialBtn: true }" @click="requestTrial">
          Trial
        </div>
      </div>
    </div>

    <div class="content">
      <div class="bgBox"></div>

      <div class="gameList">
        <div class="rowSize">


          <div class="gameBoxLi" v-if="isDevEnv">
            <div class="gameBox" @click="goToMock" style="
                background-image: url('../../static/format_list.png');
                background-color: black;
              "></div>

            <span class="gameNameBox">工具&模擬器</span>
          </div>

           <div class="gameBoxLi" v-if="showLobby && isDevEnv">
            <div class="gameBox eventbox2" @click="goGo9()"  style="background-image: url('../../static/logo_go9.png')"></div>
            <span class="gameNameBox">Go9</span>
          </div>

          <div class="gameBoxLi" v-if="showLobby">
            <div class="gameBox eventbox2" @click="eventLobby()" ></div>
            <span class="gameNameBox">來唄!輪盤轉不停</span>
          </div>

           <div class="gameBoxLi" v-if="showLobby">
            <div class="gameBox eventbox2" style="background-image: url('../../static/laibe.png')" @click="playGame({gameCode: '1999', gameName: 'hot game'})"></div>
            <span class="gameNameBox">Hot Game</span>
          </div>

          <!-- <div class="gameBoxLi" v-if="isDevEnv">
            <div class="gameBox" @click="playGame({
              gameCode: 4010,
              gameName: '猜拳奪寶電視盒版',
              gameType: 4,
              isSpecailVersion: true

            })" v-bind:style="{
              'background-image':
                'url(' + staticUrl + 'icon/' + 4010 + '.png)',
            }">
                  <div style="width:100%;height: 100%;color: red; display: flex;justify-content: center;align-items: center;font-size: 35px;font-weight: 800;">電視盒版</div>
          </div>
            <span class="gameNameBox">猜拳奪寶(電視盒版)</span>
          </div> -->


          <div v-for="(g, index) in myGames" :key="index" class="gameBoxLi">
            <div v-if="iconLan == 'zh-CN'" class="gameBox" @click="playGame(g)" v-bind:style="{
              'background-image':
                'url(' + staticUrl + 'icon/' + g.gameCode + '.png)',
            }"></div>
            <div v-else class="gameBox" @click="playGame(g)" v-bind:style="{
              'background-image':
                'url(' +
                staticUrl +
                'icon/' +
                iconLan +
                '/' +
                g.gameCode +
                '.png)',
            }"></div>

            <span class="gameNameBox">{{ g.gameName }}</span>
          </div>
          <div class="gameBoxLi" v-if="showLobby">
            <div class="gameBox eventbox" @click="playLobby()"></div>

            <span class="gameNameBox">play lobby</span>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom">
      <span class="versionTxt">Version ⚅ 1.2.1</span>
    </div>

  </div>
</template>

<script>
import { gameapiService } from "../service/gameApiService.js";
import { md5Service } from "../service/md5Service.js";
import { configData } from "../config/config.js";
import device from "current-device";
import { browserName, isSafari } from "mobile-device-detect";
import SelectLineHelper from "../service/selectLineService";

export default {
  name: "HelloWorld",
  data() {
    return {
      myGames: [],
      IsTrial: false,
      copyUrl: "",
      formData: {
        playerID: "",
        gameCode: "",
        checkValue: "",
      },
      playGameForm: {
        playerID: "",
        gameCode: "",
        returnUrl: "",
        lang: "zh-CN",
        walletType: "0",
        checkValue: "",
      },
      trialPlayGameForm: {
        gameCode: "",
        checkValue: "",
      },
      win: null,
      tmpId: "",
      merchantCode: configData.merchantCode,
      agentKey: configData.agentKey,
      domainName: configData.domain,
      staticUrl: "https://game1.ledu360.com/frontend/",
      initNum: 0,
      showLobby: true,
      langsopts: [
        { id: 0, values: "zh-CN", imgs: "../../static/langs/cn.png" },
        { id: 1, values: "th", imgs: "../../static/langs/th.png" },
        { id: 2, values: "en", imgs: "../../static/langs/en.png" },
        { id: 3, values: "vi", imgs: "../../static/langs/vn.png" },
        { id: 4, values: "zh-TW", imgs: "../../static/langs/tw.png" },
      ],
      currencys: [
        "RMB",
        "THB",
        "USD",
        "VND",
        "NTD",
        "PHP",
        "ZMW",
        "TZS",
        "KES",
        "NGN",
        "BRL",
        "JPY",
        "MYR",
        "BDT",
        "IDR",
        "KRW",
        "MXN",
        "ARS",
        "INR",
        "RUB",
        "TRY",
        "PKR",
        "EGP",
        "ZAR",
        "NTA",
        "NTB",
        "USDT"
      ],
      currentCurrency: "RMB",
      getlang: this.getLangIcon,
      showOpt: false,
      showCurrency: false,
      iconLan: "",
      withdrawalForm: {
        playerID: "",
        transferID: "",
        pointAmount: "",
        pickType: "",
        checkValue: "",
      },
      depositForm: {
        playerID: "",
        transferID: "",
        pointAmount: "",
        checkValue: "",
      },
      inputAmount: "",
      isDevEnv: ["dev", "qc", "test"].includes(configData.envName),
      isSpecailVersion: false,
    };
  },
  mounted() {
    if (["dev", "qc", "demosite", "app", "test"].indexOf(configData.envName) != -1) {
      this.formData.playerID =
        "dev" + this.pad(Math.floor(Math.random() * 10000) % 9000, 4);
    } else {
      if (configData.envName == "localProd") {
        this.formData.playerID = "adi01";
      } else {
        this.formData.playerID =
          "abc" + this.pad(Math.floor(Math.random() * 10000) % 9000, 4);
      }
    }

    if (["staging"].indexOf(configData.envName) != -1) {
      this.merchantCode = "";
      this.agentKey = "";
      this.domainName = "";
      this.$router.push({ path: "/ApiDocument" });
    }

    if (window.location.hostname.includes("arweb")) {
      this.$router.push({ path: "/ArWebSample" });
    }

    if (configData.envName == "demosite") {
      this.merchantCode = "873e89f98d9c4523b36b34a22898595f";
      this.agentKey = "dev3002";
      this.domainName = "dev001";
      //this.showLobby = false;
    }

    if (configData.envName == "app") {
      this.currencys = ["DCP"];
      this.playGameForm.lang = "en";
      this.currentCurrency = "DCP";
    }

    this.startSelectLine();
    this.getlang = this.getLangIcon;
    this.playGameForm.lang = configData.currentLang;
    this.changeMerchant();
  },
  watch: {
    merchantCode(value) {
      configData.merchantCode = value;
    },
    agentKey(value) {
      configData.agentKey = value;
    },
    domainName(value) {
      configData.domain = value;
    },
    initNum(val) {
      if (configData.envName == "demosite") return;
      if (val == 10) {
        this.$router.push({ path: `/ApiDocument` });
      }
    },
  },
  methods: {
    initDoc() {
      this.initNum++;
    },
    requestTrial() {
      this.IsTrial = !this.IsTrial;
    },
    goToMock() {
      this.$router.push({ path: `/GameMock` });
    },
    playTrialGame() {
      this.IsTrial = !this.IsTrial;
    },
    changeKey() {
      configData.agentKey = this.agentKey;
    },
    changeDomain() {
      configData.domain = this.domainName;
    },
    openWindow(url) {
      this.win.location.href = url;
    },
    setLangs(item) {
      this.iconLan = item.values;
      this.getlang = item.imgs;
      this.playGameForm.lang = item.values;
      configData.currentLang = item.values;
      this.getGameList();
    },
    onCurrencyChange() {
      configData.currentCurrency = this.currentCurrency;
      this.changeMerchant();
    },
    changeMerchant() {
      if (
        configData.envName == "dev" ||
        configData.envName == "qc" ||
        configData.envName == "demosite" ||
        configData.envName == "prod" ||
        configData.envName == "local" ||
        configData.envName == "localProd"
      ) {
        this.merchantCode =
          configData.playgameSetting[configData.currentCurrency].merchantCode;
        this.domainName =
          configData.playgameSetting[configData.currentCurrency].domain;
        this.agentKey =
          configData.playgameSetting[configData.currentCurrency].agentKey;

        // configData.merchantCode =
        //   configData.playgameSetting[configData.currentCurrency].merchantCode;
        // configData.agentKey =
        //   configData.playgameSetting[configData.currentCurrency].agentKey;
        // configData.domain =
        //   configData.playgameSetting[configData.currentCurrency].domain;
        // if (configData.currentCurrency == "THB") {
        //   this.merchantCode = configData.merchantCodeTH;
        //   this.domainName = configData.domainTH;
        //   this.agentKey = configData.agentKeyTH;
        // } else if (configData.currentCurrency == "USD") {
        //   this.merchantCode = configData.merchantCodeEN;
        //   this.domainName = configData.domainEN;
        //   this.agentKey = configData.agentKeyEN;
        // } else if (configData.currentCurrency == "VND") {
        //   this.merchantCode = configData.merchantCodeVI;
        //   this.domainName = configData.domainVI;
        //   this.agentKey = configData.agentKeyVI;
        // } else if (configData.currentCurrency == "NTD") {
        //   this.merchantCode = configData.merchantCodeTW;
        //   this.domainName = configData.domainTW;
        //   this.agentKey = configData.agentKeyTW;
        // } else if (configData.currentCurrency == "PHP") {
        //   this.merchantCode = configData.merchantCodePHP;
        //   this.domainName = configData.domainPHP;
        //   this.agentKey = configData.agentKeyPHP;
        // } else if (configData.currentCurrency == "ZMW") {
        //   this.merchantCode = configData.merchantCodeZMW;
        //   this.domainName = configData.domainZMW;
        //   this.agentKey = configData.agentKeyZMW;
        // } else if (configData.currentCurrency == "TZS") {
        //   this.merchantCode = configData.merchantCodeTZS;
        //   this.domainName = configData.domainTZS;
        //   this.agentKey = configData.agentKeyTZS;
        // }  else if (configData.currentCurrency == "KES") {
        //   this.merchantCode = configData.merchantCodeKES;
        //   this.domainName = configData.domainKES;
        //   this.agentKey = configData.agentKeyKES;
        // } else if (configData.currentCurrency == "NGN") {
        //   this.merchantCode = configData.merchantCodeNGN;
        //   this.domainName = configData.domainNGN;
        //   this.agentKey = configData.agentKeyNGN;
        // } else if (configData.currentCurrency == "BRL") {
        //   this.merchantCode = configData.merchantCodeBRL;
        //   this.domainName = configData.domainBRL;
        //   this.agentKey = configData.agentKeyBRL;
        // } else if (configData.currentCurrency == "JPY") {
        //   this.merchantCode = configData.merchantCodeJPY;
        //   this.domainName = configData.domainJPY;
        //   this.agentKey = configData.agentKeyJPY;
        // }  else {
        //   this.merchantCode = configData.merchantCodeCN;
        //   this.domainName = configData.domainCN;
        //   this.agentKey = configData.agentKeyCN;
        // }
      }
    },
    requestShow() {
      this.showOpt = !this.showOpt;
    },
    requestShowCurrency() {
      this.showCurrency = !this.showCurrency;
    },
    startSelectLine() {
      let selectLineHelper = new SelectLineHelper();
      selectLineHelper.init();
      selectLineHelper.setConfigLocation(configData.lineUrl);
      selectLineHelper.setFinishJob((info, data) => {
        configData.frontendAPI = data.frontendAPI;
        this.getGameList();
      });
      selectLineHelper.startSelectLine();
    },
    getGameList() {
      //if (configData.envName == "demosite") {
      gameapiService.getAllEnableGameSort().then((res) => {
        this.myGames = res.data.data.enableGameList;
      });
      // } else {
      //   gameapiService.getallenablegame3().then((res) => {
      //     this.myGames = res.data.data.enableGameList;
      //   });
      // }
    },
    async autoWithdrawalAndDeposite() {
      await this.playerWithdrawal();
      if (this.playGameForm.walletType != 2) {
        await this.playerDeposit();
      }
    },
    async playerWithdrawal() {
      this.withdrawalForm.playerID = this.formData.playerID;
      this.withdrawalForm.pickType = "F";
      this.withdrawalForm.transferID = "withdrawal" + Date.now();
      this.withdrawalForm.pointAmount = 0;

      this.withdrawalForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.withdrawalForm.playerID,
        this.withdrawalForm.pickType,
        this.withdrawalForm.transferID,
        this.withdrawalForm.pointAmount,
      ]);

      await gameapiService.withdrawal(this.withdrawalForm).then((res) => { });
    },
    async playerDeposit() {
      if (
        !this.inputAmount ||
        this.inputAmount > 10000000 ||
        this.inputAmount <= 0
      ) {
        this.inputAmount = 1000000;
      }

      if(["NTA","NTB"].includes(configData.currentCurrency)) {
        this.inputAmount = 1000;
      }

      this.depositForm.playerID = this.formData.playerID;
      this.depositForm.transferID = "deposit" + Date.now();
      this.depositForm.pointAmount = this.inputAmount;
      this.depositForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.depositForm.playerID,
        this.depositForm.transferID,
        this.depositForm.pointAmount,
      ]);

      await gameapiService.deposit(this.depositForm).then((res) => { });
    },
    async createPlayer() {
      let createPlayerForm = {
        playerID: this.formData.playerID,
        checkValue: md5Service.encWithoutKey([
          this.merchantCode,
          this.agentKey,
          this.formData.playerID,
        ]),
      };
      try {
        await gameapiService.createPlayer(createPlayerForm);
      } catch (err) { }
    },
    async playGame(game) {
      if (this.isIphone() && !this.Check_CN_Browser(browserName)) {
        this.win = window.open('', 'T9-Game');
      }
      if (this.IsTrial) {
        // 試玩玩家
        this.setTrialInfo(game);
        this.trialPlayGameAPI();
        return;
      }

      if (
        !this.IsTrial &&
        this.playGameForm.walletType != 2 &&
        ["dev", "qc", "test", "demosite", "app"].indexOf(configData.envName) !=
        -1
      ) {
        await this.createPlayer();
      }
      // 正式玩家
      if (["dev", "qc", "test"].includes(configData.envName) && !this.IsTrial) {
        await this.autoWithdrawalAndDeposite();
      }

      if (game.isSpecailVersion) {
        this.isSpecailVersion = game.isSpecailVersion;
      } else {
        this.isSpecailVersion = false;
      }

      this.setPlayGameInfo(game);
      this.lobbyPlayGameAPI();
    },

    playLobby() {
      if (this.isIphone() && !this.Check_CN_Browser(browserName)) {
        this.win = window.open('', 'T9-Game');
      }
      if (this.IsTrial) {
        return;
      }
      // 正試玩家
      // this.setPlayGameInfo(game);
      // this.lobbyPlayGameAPI();
      this.formData.gameCode = "";
      this.formData.checkValue = md5Service.enc([
        this.formData.playerID,
        this.formData.gameCode,
      ]);

      this.formData.lang = configData.currentLang;

      gameapiService.playlobby(this.formData).then((res) => {
        // Error
        if (res.data.statusCode == 1130) {
          alert(
            "Area Deny，You Can't Visit This WebSite" + res.data.errorMessage
          );
        }
        if (res.data.statusCode !== 200) {
          setTimeout(this.win.close(), 100);
          return;
        }
        // Success
        // this.checkDevOr64(res.data.data);
        // this.gameOpenWay();
        let eventUrl = res.data.data;
        this.win = window.open(eventUrl, 'T9-Game');

        if (this.isIphone() && this.Check_CN_Browser(browserName)) {
          this.win.location.href = eventUrl;
          //location.href = eventUrl;
        }
      });
    },
    eventLobby() {
      if (this.isIphone() && !this.Check_CN_Browser(browserName)) {
        this.win = window.open('', 'T9-Game');
      }
      if (this.IsTrial) {
        return;
      }
      // 正試玩家
      // this.setPlayGameInfo(game);
      // this.lobbyPlayGameAPI();
      this.formData.gameCode = "";
      this.formData.checkValue = md5Service.enc([
        this.formData.playerID,
        this.formData.gameCode,
      ]);

      gameapiService.eventlobby(this.formData).then((res) => {
        // Error
        if (res.data.statusCode == 1130) {
          alert(
            "Area Deny，You Can't Visit This WebSite" + res.data.errorMessage
          );
        }
        if (res.data.statusCode !== 200) {
          setTimeout(this.win.close(), 100);
          return;
        }
        // Success
        // this.checkDevOr64(res.data.data);
        // this.gameOpenWay();
        let eventUrl = res.data.data;
        this.win = window.open(eventUrl, 'T9-Game');

        if (this.isIphone() && this.Check_CN_Browser(browserName)) {
          this.win.location.href = eventUrl;
          //location.href = eventUrl;
        }
      });
    },
    goGo9(){
        let eventUrl = "http://192.168.5.25:3000";
        this.win = window.open(eventUrl, 'T9-Game');

        if (this.isIphone() && this.Check_CN_Browser(browserName)) {
          this.win.location.href = eventUrl;
          //location.href = eventUrl;
        }
    },

    Check_CN_Browser(browser) {
      // WebKit (360 Iphone) |  WebView (360 Android)
      // IE不支援includes
      return [
        "UCBrowser",
        "QQBrowser",
        "WebKit",
        "IE",
        "WebView",
        "Chrome WebView",
        "baidu",
      ].includes(browser);
    },
    async gameOpenWay() {
      if (["test"].indexOf(configData.envName) != -1) {
        this.copyUrl = this.copyUrl.replace('192.168.5.211:81', 'testgameweb.tiangeo.com');
      }

      if (this.Check_CN_Browser(browserName) || this.isMacSafari()) {
        this.win.location.href = this.copyUrl;
        //location.href = this.copyUrl;
        return;
      }

      if (this.isSpecailVersion) {
        if (this.copyUrl.includes("&line=")) {
          // 將查詢參數line的值取代為指定的
          this.copyUrl = this.copyUrl.replace(/line=[^&]*/, "line=4");
        } else {
          this.copyUrl = this.copyUrl + "&line=4";
        }

        //let version = prompt("請輸入版號");
        let version = "e3493397";
        if (version) {
          this.copyUrl = this.copyUrl.replace(/version=[^&]*/, "version=" + version);
        } else {
          return;
        }
      }

      // if(window.location.hostname === 'staging.tiangeo168.com') {
      //   this.copyUrl = this.copyUrl.replace('gameweb.tjgame888.com', 'staging.tiangeo168.com/gameweb');
      // }

      this.win = window.open(this.copyUrl, 'T9-Game');
    },
    trialPlayGameAPI() {

      gameapiService.trialPlayGame(this.trialPlayGameForm).then((res) => {
        // Error
        if (res.data.statusCode == 1130) {
          alert(
            "Area Deny，You Can't Visit This WebSite" + res.data.errorMessage
          );
        }
        if (res.data.statusCode !== 200) {
          setTimeout(this.win.close(), 100);
          return;
        }
        // Success
        this.checkDevOr64(res.data.data);
        this.gameOpenWay();
      });
    },
    lobbyPlayGameAPI() {
      if (this.playGameForm.walletType == 3 && ["dev"].indexOf(configData.envName) != -1) {
        // this.merchantCode = "b4434d6778b44b27950db64a80060fdc";
        // this.domainName ="jdbrmb";
        // this.agentKey ="jdbrmb_agent";
        gameapiService.outerWalletPlayGame({
          playerId: this.playGameForm.playerID,
          gameCode: this.playGameForm.gameCode,
          currency: configData.currentCurrency
        }).then((res) => {
          // Error
          if (res.data.statusCode == 1130) {
            alert(
              "Area Deny，You Can't Visit This WebSite" + res.data.errorMessage
            );
          }
          if (res.data.statusCode !== "0000") {
            setTimeout(this.win.close(), 100);
            return;
          }
          // Success
          this.checkDevOr64(res.data.url);
          this.gameOpenWay();
        });

        return;
      } else {

      }

      gameapiService.playGame(this.playGameForm).then((res) => {
        // Error
        if (res.data.statusCode == 1130) {
          alert(
            "Area Deny，You Can't Visit This WebSite" + res.data.errorMessage
          );
        }
        if (res.data.statusCode !== 200) {
          setTimeout(this.win.close(), 100);
          return;
        }
        // Success
        this.checkDevOr64(res.data.data);
        this.gameOpenWay();
      });
    },

    setTrialInfo(game) {
      this.trialPlayGameForm.gameCode = game.gameCode;
      this.trialPlayGameForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.trialPlayGameForm.gameCode,
      ]);
    },
    setPlayGameInfo(game) {
      // this.formData.gameCode = game.gameCode;
      // this.formData.checkValue = md5Service.enc([
      //   this.formData.playerID,
      //   this.formData.gameCode,
      // ]);
      this.playGameForm.playerID = this.formData.playerID;
      this.playGameForm.gameCode = game.gameCode;
      this.playGameForm.checkValue = md5Service.enc([
        this.playGameForm.playerID,
        this.playGameForm.gameCode,
      ]);
    },
    isIphone() {
      let res = false;
      if (device.mobile() && device.ios()) res = true;
      return res;
    },
    isMacSafari() {
      let res = false;
      if (!device.mobile() && isSafari) res = true;
      return res;
    },
    checkDevOr64(url) {
      if (configData.gameWebUrl.match("228")) {
        this.copyUrl = configData.gameWebUrl + "?" + url.split("?")[1];
      } else {
        this.copyUrl = url;
      }
    },
    pad(n, width, z) {
      z = z || "0";
      n = n + "";
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    },
  },
  computed: {
    getLangIcon() {
      var i = this.langsopts.filter((l) => {
        return l.values == configData.currentLang;
      });
      return i[0].imgs;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  padding: 15px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 2px 8px #00ebfe;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  background-color: #1e1e1e;
  width: 100%;
  z-index: 2;
}

#logo {
  width: 120px;
  margin: 8px;
}

.idType {
  padding: 8px;
  border-radius: 8px;
  width: 120px;
}

.playerBox {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.trialBtn {
  padding: 5px;
  margin: 0 8px;
  border: 2px solid #ffb700;
  color: #ffb700;
  letter-spacing: 1px;
  cursor: pointer;
  border-radius: 5px;
  user-select: none !important;
}

.hasTrial {
  background-color: #ffb700;
  color: #1e1e1e;
  font-weight: 700;
}

.versionTxt {
  font-size: 10px;
  letter-spacing: 1px;
  color: rgb(143, 143, 143);
  font-weight: 700;
}

.bottom {
  padding: 8px;
  box-shadow: 0 -3px 8px #00ebfe;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #1e1e1e;
  width: 100%;
}

.gameList {
  background-image: url("../assets/bg3.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  min-height: 100vh;
}

.rowSize {
  width: 60%;
  margin: 0 auto;
  margin-bottom: 37px;
}

.gameBoxLi {
  display: inline-block;
  margin: 10px 20px;
}

.gameBox {
  width: 200px;
  height: 200px;
  box-sizing: border-box;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #e704c2;
  border-radius: 10px;
  box-shadow: 0 0 8px 3px #e704c2;
  margin: 10px;
  cursor: pointer;
}

.gameNameBox {
  font-weight: 700;
  font-family: arial, "Microsoft JhengHei", "微軟正黑體", sans-serif !important;
  letter-spacing: 2px;
}

.langBox {
  width: 60px;
  height: 35px;
  background-color: #fff;
  border-radius: 8px;
  margin: 0 5px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.currencyBox {
  width: 60px;
  height: 35px;
  background-color: #fff;
  border-radius: 8px;
  margin: 0 5px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.selectClass {
  border: 0;
}

.optionClass {
  font-size: 15px;
}

.langOptions {
  width: 150px;
  height: 300px;
  position: absolute;
  background-color: rgb(255, 255, 255);
  top: 40px;
  left: 0;
  border-radius: 8px;
  overflow-y: scroll;
  padding: 10px;
  color: #222;
}

.langOptions::-webkit-scrollbar {
  width: 5px;
}

.langOptions::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  margin: 80px 0 5px 0;
  background-color: #069faa;
}

.langItem {
  padding: 12px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #ccc;
  font-weight: 900;
}

.langItem:hover {
  color: #ff9811;
}

#mylang {
  width: 30px;
  height: 20px;
  margin: 0 3px;
}

.optlang {
  margin-right: 15px !important;
}

.eventbox {
  background-image: url("../assets/t9_lobby.png");
  background-color: black;
}

.eventbox2 {
  background-image: url("../assets/1000020icon.png");
}

@media screen and (max-width: 1750px) {
  .rowSize {
    width: 70%;
  }
}

@media screen and (max-width: 1503px) {
  .rowSize {
    width: 80%;
  }
}

@media screen and (max-width: 1316px) {
  .rowSize {
    width: 100%;
  }
}

@media screen and (max-width: 1024px) {
  .gameBoxLi {
    display: inline-block;
    margin: 10px;
  }

  .rowSize {
    width: 80%;
  }
}

@media screen and (max-width: 768px) {
  .rowSize {
    width: 100%;
  }
}

@media screen and (max-width: 414px) {
  .top {
    flex-direction: column;
  }

  .gameBox {
    margin: 10px 0;
    width: 144px;
    height: 144px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue